/**
 *  分模块翻译，方便维护
 *  lang/en-US/module/common.js
 */

export default {
  "common": {
    "lang": "Language",
    "chinese": "Chinese",
    "english": "English",

    "model_list": "Model List",
    "start": "Start",
    "lead": "Lead",
    "approved": "Approved",
    "done": "Done",
    "spu": "Part#",
    "brand": "Brand",
    "category": "Categ",
    "date_code": "D/C",
    "lead_time": "L/T",
    "packing": "Packing",
    "coo": "C.O.",
    "qty": "Qty",
    "price": "Price",
    "shop": "Shop",
    "member": "Mem.",
    "created": "Create",
    "updated": "Update",
    "type": "Type",
    "status": "Status",
    "remark": "Remark",
    "description": "Desc.",
    "warehouse": "WH",
    "tags": "Tags",
    "tax_categ": "Tax",

    "latest":"Latest",
    "frequency":"Frequency",

    "rfq_qty": "RFQ Qty",
    "buy_qty": "Buy Qty",
    "avab_qty": "AVAB Qty",
    "sell_qty": "Sell Qty",
    "trade_qty": "TX Qty",
    "tx_amount": "TX Amount",

    "title": "Title",
    "column": "Column",
    "column_layout": "Column Layout",
    "column_manager": "Column Manager",
    "fixed_column": "Fixed column",
    "author": "Author",
    "date": "Date",
    "read": "Read",
    "like": "Like",
    "favorite": "Favorite",
    "comment": "Comment",
    "share": "Share",
    "article_list": "Article List",
    "view_more": "View More",
    "eccn_number": "ECCN Number",
  },
  "tip": {
    "search": "Search...",
    "select": "Please select",
    "please_enter": "Please Enter",
    "column_search": "Failed to query column information!",
    "no_editable": "(Note: Once the published draft is published, it will no longer be editable.)",
    "positive_integers": "Planned invitations must be positive integers",
    "allowed_upload": "Only JPG, GIF, BMP, PNG, TIF, and RAW formats are allowed for image uploads!",
    "image_size": "The image size cannot exceed 20MB!",
    "single_image": "Only a Single image can be uploaded",
    "spu_not_matched": "This model could not be matched from the database. The product manager is processing, and matching information will be displayed after processing is complete.",
    "aliases": "Please enter aliases here, separated by '|'.",
    "former": "Please enter former names, separated by '|'.",
    "catalog_price": "Confirm current catalog price?",
  },
  "validate": {
    "user": "Please Enter Mobile/Email/Username",
    "password": "Please enter your password",
    "phone_number": "Please enter your phone number",
    "correct_phone": "Please enter a Valid phone number",
    "code": "Please enter the Verification code",
    "captcha": "Please enter the Image verification code",
    "user_name": "Please enter your Username",
    "user_rule": "Please enter 6-20 Characters,#s, or Symbols",
  },
  "button": {
    "search": 'Search',
    // portal/sku
    "disk_allocation": 'Matching',
    "inquiry": 'Inquiry',
    "supply": 'Supply',
    "sale": 'Sales',
    "purchase": 'Purchase',
    "clear": 'Clear',

    "create": 'Create',
    "edit": 'Edit',
    "delete": 'Delete',
    "view": 'View',
    "copy": 'Copy',
    "paste": 'Paste',
    "download": 'Download',
    "upload": 'Upload',
    "export": 'Export',
    "import": 'Import',
    "print": 'Print',
    "save": 'Save',
    "cancel": 'Cancel',
    "confirm": 'Confirm',
    "submit": 'Submit',
    "reset": 'Reset',
    "assign": 'Assign',
    "approved": "Approved",
    "rejected": "Rejected",
    "review": "Review",
    "active": "Active",
    "archive": "Archive",
    "apply": "Apply",
    "approval": "Approval",
  }
};
